import { IChipProps, TIconName } from '@mofid-securities/uikit';
import { truncateDecimal } from '@/utils/number';

export interface IGenerateEfficiencyForChipReturn
  extends Pick<IChipProps, 'variant'> {
  formattedEfficiency: string;
  textColorClass: string;
  icon: TIconName | null;
}

export const generateEfficiencyForChip = (
  efficiency: number,
  decimalLength: number = 2
): IGenerateEfficiencyForChipReturn => {
  let variant: IChipProps['variant'] = 'default';

  let textColorClass: string = 'text-gray-filled-secondary-enabled';

  let icon: TIconName | null = null;

  if (typeof efficiency !== 'number') {
    return {
      formattedEfficiency: '-',
      variant,
      textColorClass,
      icon,
    };
  }

  if (typeof decimalLength !== 'number' || decimalLength < 0) {
    throw new Error('Invalid decimal length');
  }

  let formattedEfficiency: string = truncateDecimal(efficiency, decimalLength);

  if (efficiency === 0) {
    formattedEfficiency = '-';
  } else if (efficiency > 0) {
    formattedEfficiency = `+${formattedEfficiency}`;
  } else if (efficiency < 0) {
    formattedEfficiency = `${formattedEfficiency}`;
  }

  if (efficiency > 0) {
    variant = 'success';
    textColorClass = 'text-success-filled-primary-enabled';
    icon = 'caret_up';
  } else if (efficiency < 0) {
    variant = 'error';
    textColorClass = 'text-error-filled-primary-enabled';
    icon = 'caret_down';
  }

  return {
    formattedEfficiency,
    variant,
    textColorClass,
    icon,
  };
};
